<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Components</span>
        <h3 class="page-title">Channel</h3>
      </div>
    </div>

    <d-alert
      dismissible
      :show="timeUntilDismissed"
      theme="success"
      @alert-dismissed="timeUntilDismissed = 0"
      @alert-dismiss-countdown="handleTimeChange"
    >
      <b>Success!</b> This alert will will be dismissed in
      {{ timeUntilDismissed }} seconds!
    </d-alert>

    <p align="right">
      <d-col lg="3" md="12">
        <d-input-group class="mb-2">
          <d-input placeholder="New category" v-model="category" />
          <d-input-group-addon append>
            <d-button v-on:click.prevent="create()" class="btn-white px-2"
              ><i class="material-icons">add</i></d-button
            >
          </d-input-group-addon>
        </d-input-group>
      </d-col>
    </p>

    <!-- First Row of Posts -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Channel</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Name</th>
                  <th scope="col" class="border-0">Visibility</th>
                  <th scope="col" class="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(category) in categories"
                  :value="category.id"
                  :key="category.id"
                >
                  <td><input class="form-control form-control" v-model="category.name" @keyup.enter="enterClicked(category.id, category.name)"/></td>
                  <th><i class="material-icons mr-1">visibility</i></th>
                  <td>
                    <d-button
                      theme="danger"
                      v-on:click="deleteData(category.id)"
                      ><i class="material-icons">delete</i></d-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </d-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      categories: [],
      category: "",
      duration: 5,
      timeUntilDismissed: 0,
    };
  },
  mounted: function () {
    this.loadPage();
  },
  methods: {
    enterClicked(id, name){
      axios
        .put("https://wepark-backend.ive.appliedtech.ltd/api/staff/Category/" + id,{
          translations: {
            en: {
              name: name
            },
            zh_hans: {
              name: name
            },
            zh_hant: {
              name: name
            }
          },
          published: true
        })
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.timeUntilDismissed = this.duration;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadPage() {
      await axios
        .get(process.env.VUE_APP_API+"api/staff/Category")
        .then((response) => {
          this.categories = response.data.result.result;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async deleteData(id) {
      await this.$confirm("Are you sure?", "Delete Channel")
        .then(() => {
          axios
            .delete(
              process.env.VUE_APP_API+"api/staff/Category/" +
                id
            )
            .then((response) => {
              this.loadPage();
            });

          this.$alert("success");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleTimeChange(time) {
      this.timeUntilDismissed = time;
    },
    async create() {
      await axios
        .post(process.env.VUE_APP_API+"api/staff/Category", {
          translations: {
            en: {
              name: this.category
            },
            zh_hans: {
              name: this.category
            },
            zh_hant: {
              name: this.category
            }
          },
          published: true
        })
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.timeUntilDismissed = this.duration;
          }
        })
      this.loadPage();
    },
  },
};
</script>
